module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_points.8ac0dd8f.png";